import { MigrationSpec } from "../migration.models"

/**
 * qpien-ai's `AiHoldMigrationService` deletes every row it reads, adopted or orphaned, so the row
 * reads APPLIED once the collection is empty. A row it could not move stays and is listed.
 */
const aiPersonMemoryToSessions: MigrationSpec = {
  type: "MIGRATE_AI_PERSON_MEMORY_TO_SESSIONS",
  collection: "AiPersonMemory",
  risk: "DESTRUCTIVE",
  title: {
    en: "AI memory: move the AI's hold on each conversation into its agent session",
    tr: "AI hafızası: AI'ın konuşmadaki durumunu ajan oturumuna taşı"
  },
  description: {
    en:
      "For every AiPersonMemory row the conversation still points at (Conversations.aiPersonMemory), " +
      "writes its role, status, auto-close and follow-up schedule, introduction flag and page URL " +
      "into AiAgentSessions.hold under the same id, so the pointer stays valid; the language goes " +
      "to the session when it has none. Rows no conversation points at are orphans and are only " +
      "deleted. Every row read is deleted; the stored transcript is not carried over.",
    tr:
      "Konuşmanın hâlâ işaret ettiği (Conversations.aiPersonMemory) her AiPersonMemory satırının " +
      "rolünü, durumunu, otomatik kapanış ve takip zamanlamasını, tanıtım bayrağını ve sayfa " +
      "adresini aynı kimlikle AiAgentSessions.hold'a yazar; işaretçi geçerli kalır. Oturumda dil " +
      "yoksa dil de taşınır. Hiçbir konuşmanın işaret etmediği satırlar sahipsizdir ve yalnızca " +
      "silinir. Okunan her satır silinir; kayıtlı transkript taşınmaz."
  },
  affectedFilter: {},
  sampleFields: [
    "customer",
    "conversation",
    "status",
    "autoCloseTime",
    "updatedAt"
  ],
  notes: [
    {
      en:
        "Deploy qpien-ai first. From that deploy on, v2 writes only the session hold; until this " +
        "runs, conversations idle since before the deploy keep their old auto-close and follow-up " +
        "schedule unswept.",
      tr:
        "Önce qpien-ai deploy edilmelidir. O deploy'dan sonra v2 yalnızca oturumdaki hold'u yazar; " +
        "bu migration çalışana kadar deploy öncesinden beri bekleyen konuşmaların eski otomatik " +
        "kapanış ve takip zamanlaması taranmaz."
    },
    {
      en: "v1 still reads AiPersonMemory: a tenant left on v1 loses its auto-close.",
      tr: "v1 hâlâ AiPersonMemory okur: v1'de kalan bir müşterinin otomatik kapanışı çalışmaz."
    }
  ]
}

export default aiPersonMemoryToSessions
